import React from "react";

const AmenitiesV2 = (props) => {
  let listing,
    bedrooms,
    bathrooms,
    interiorSquareFeet,
    acreage,
    exSquareFeet,
    lotSize;
  listing = props.listing;

  bedrooms = listing.bedroomCount ? (
    <div className="single-amen-container">
      <div className="count">{listing.bedroomCount}</div>
      <div className="copy">BEDROOM(S)</div>
    </div>
  ) : (
    ""
  );

  bathrooms = () => {
    let bathroom,
      partialBathroomCount,
      partialBathrooms,
      bathroomCopy,
      displayBaths,
      splitLimit;

    if (listing.source === "global") {
      splitLimit = 4;
    } else {
      splitLimit = 3;
    }

    bathroom = listing.bathCount.split(" ")[0];
    partialBathroomCount = listing.bathCount.split(" ")[splitLimit];

    if (bathroom === "undefined") {
      return "";
    }

    if (typeof partialBathroomCount !== "undefined") {
      partialBathrooms = ` / ${listing.bathCount.split(" ")[splitLimit]}`;
      bathroomCopy = `FULL / PARTIAL BATH(S)`;
    } else {
      partialBathrooms = "";
      bathroomCopy = "FULL BATH(S)";
    }

    displayBaths = listing.bathCount ? (
      <div className="single-amen-container">
        <div className="count">{`${bathroom}${partialBathrooms}`}</div>
        <div className="copy">{bathroomCopy}</div>
      </div>
    ) : (
      ""
    );

    return displayBaths;
  };

  interiorSquareFeet = listing.interiorSquareFeet ? (
    <div className="single-amen-container">
      <div className="count">
        {listing.interiorSquareFeet
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        &plusmn;
      </div>
      <div className="copy">INTERIOR SQUARE FEET</div>
    </div>
  ) : (
    ""
  );

  exSquareFeet = listing.exteriorSize ? (
    <div className="single-amen-container">
      <div className="count">
        {listing.exteriorSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        &plusmn;
      </div>
      <div className="copy">EXTERIOR SQUARE FEET</div>
    </div>
  ) : (
    ""
  );

  lotSize = listing.lotSize ? (
    <div className="single-amen-container">
      <div className="count">{listing.lotSize}&plusmn;</div>
      <div className="copy">LOT SIZE SQUARE FEET</div>
    </div>
  ) : (
    ""
  );

  acreage = listing.acreage ? (
    <div className="single-amen-container">
      <div className="count">
        {Math.floor(parseFloat(listing.acreage) * 10) / 10}&plusmn;
      </div>
      <div className="copy">ACRES</div>
    </div>
  ) : (
    ""
  );

  return (
    <div className="totalAmenities">
      {bedrooms}
      {bathrooms()}
      {interiorSquareFeet}
      {exSquareFeet}
      {lotSize}
      {acreage}
    </div>
  );
};

export default AmenitiesV2;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/amenitiesv2.js